import React from 'react';
import cx from 'classnames';
import { Lock } from '@vedmarket/ui-kit';
import { useTranslation } from 'react-i18next';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

import './locked-icon-badge.scss';

const LockedIconBadge = ({ children, className }: CommonLockedIconBadgeProps) => (
  <span className={cx('locked-icon-badge', className)}>
    <span className='locked-icon-badge__icon'>
      {children}
    </span>
    <span className='locked-icon-badge__pin' aria-hidden>
      <Lock
        className='locked-icon-badge__lock-svg'
        style={{
          width: 12,
          height: 12,
        }}
        aria-hidden
        focusable='false'
      />
    </span>
  </span>
);

export const ReadOnlyLockEndBadge = ({ className }: CommonReadOnlyLockEndBadgeProps) => {
  const { t } = useTranslation();

  return (
    <Tooltip placement='right' title={(
      <Typography variant='body2'>{t('calc__text__submittedForPreparation')}</Typography>
    )}>
      <span className={cx('read-only-lock-end', className)}>
        <Lock className='read-only-lock-end__icon' width={10} height={10} aria-hidden focusable='false' />
      </span>
    </Tooltip>
  );
};

export default LockedIconBadge;
